<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::sidebar-->
      <navbar-component></navbar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->

        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <h4 style="margin-right: 5px" class="float-start">
                    Inventory
                  </h4>
                  <button
                    v-if="permision_role.method_read"
                    class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()"
                  >
                    <i class="link-icon mdi mdi-download"></i>
                    {{ $t("downloadData") }} .xlsx
                  </button>
                  <!-- <button v-if="permision_role.method_read" class="btn btn-dark float-end btn-xs"
                      style="margin-right: 5px" @click="massUploadSo()" type="button">
                      <i class="link-icon mdi mdi-upload"></i>
                      Upload SO .xlsx
                    </button> -->
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="exampleInputText1">Warehouse Id</label>
                        <v-select
                          :options="fetchFulfillment"
                          v-model="fulfillmentSelected"
                          label="code"
                          return-object
                          @search="asyncSearchFulfillment"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.code }} | {{ option.name }}
                          </template>
                        </v-select>
                      </div>
                    </div>

                    <!-- <div class="col-sm-3">
                      <div class="form-group">
                        <label for="exampleInputText1">Inventory Date</label>
                        <date-range-picker
                          style="width: 100%;"
                          control-container-class="form-control set-height"
                          :locale-data="locale"
                          v-model="dateFilter"
                          :opens="'center'"
                          :singleDatePicker="true"
                          :timePicker24Hour="true"
                          :timePicker="false"
                          :showWeekNumbers="false"
                          :append-to-body="false"
                        >
                        </date-range-picker>
                      </div>
                    </div> -->
                    <!-- <div class="col-sm-1">
                      <div class="form-group">
                        <label for="exampleInputText1">Page No</label>
                        <input
                          type="number"
                          class="form-control"
                          v-model="search.pageNo"
                          placeholder="Page No"
                        />
                      </div>
                    </div>
                    <div class="col-sm-1">
                      <div class="form-group">
                        <label for="exampleInputText1">Page Size</label>
                        <input
                          type="number"
                          class="form-control"
                          v-model="search.pageSize"
                          placeholder="Page Size"
                        />
                      </div>
                    </div> -->
                    <!-- </div>
                  <div class="row my-2"> -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="exampleInputText1">Customer Id</label>
                        <multiselect
                          @search-change="asyncCustomer"
                          v-model="companySelected"
                          :custom-label="customType"
                          :options="fetchCustomer"
                          track-by="code"
                        >
                          <span slot="noResult"
                            >Oops! No elements found. Consider changing the
                            search query.</span
                          >
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label for="exampleInputText1">Sku</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Sku"
                          v-model="search.sku"
                        />
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <button
                        class="btn btn-primary mx-2"
                        @click="
                          () => {
                            this.serverParams.page = 1;
                            loadItems();
                          }
                        "
                      >
                        Cari
                      </button>
                      <button class="btn btn-primary mx-2" @click="clearSearch">
                        Reset
                      </button>
                    </div>
                  </div>
                  <div class="row my-4">
                    <div class="col-lg-12 col-xl-12">
                      <vue-good-table
                        title="list-flux-master-sku"
                        ref="list-flux-master-sku"
                        :rows="rows"
                        mode="remote"
                        :columns="columns"
                        :line-numbers="true"
                        :isLoading.sync="isLoading"
                        @on-per-page-change="onPerPageChange"
                        @on-page-change="onPageChange"
                        :pagination-options="{
                          enabled: true,
                          perPageDropdown: [10, 25, 50, 100],
                          dropdownAllowAll: false,
                        }"
                        :sort-options="{
                          enabled: false,
                        }"
                      >
                        <!-- slot-scope="props" -->
                        <template slot="pagination-bottom">
                          <!-- <custom-pagination
                            :total="props.total"
                            :pageChanged="props.pageChanged"
                            :perPageChanged="props.perPageChanged">
                          </custom-pagination> -->
                          <div class="vgt-wrap__footer vgt-clearfix">
                            <div class="footer__row-count vgt-pull-left">
                              <form>
                                <label class="footer__row-count__label"
                                  >Rows per page:</label
                                >
                                <select
                                  v-model="serverParams.per_page"
                                  @change="
                                    onPerPageChange({
                                      currentPerPage: serverParams.per_page,
                                    })
                                  "
                                  autocomplete="off"
                                  name="perPageSelect"
                                  aria-controls="vgt-table"
                                  class="footer__row-count__select"
                                >
                                  <option value="10">10</option>
                                  <option value="25">25</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <!---->
                                </select>
                              </form>
                            </div>
                            <div class="footer__navigation vgt-pull-right">
                              <!---->
                              <div
                                data-v-347cbcfa=""
                                class="footer__navigation__page-info"
                              >
                                <div data-v-347cbcfa="">Page : {{ this.serverParams.page }}</div>
                              </div>
                              <button
                                type="button"
                                aria-controls="vgt-table"
                                class="footer__navigation__page-btn"
                                :class="{
                                  disabled: !prevButtonEnabled,
                                }"
                                :disabled="!prevButtonEnabled"
                                @click="
                                  onPageChange({
                                    currentPage: serverParams.page - 1,
                                  })
                                "
                              >
                                <span
                                  aria-hidden="true"
                                  class="chevron left"
                                ></span>
                                <span>Previous</span>
                              </button>
                              <button
                                type="button"
                                aria-controls="vgt-table"
                                :class="{
                                  disabled: !nextButtonEnabled,
                                }"
                                :disabled="!nextButtonEnabled"
                                class="footer__navigation__page-btn"
                                @click="
                                  onPageChange({
                                    currentPage: serverParams.page + 1,
                                  })
                                "
                              >
                                <span>Next</span>
                                <span
                                  aria-hidden="true"
                                  class="chevron right"
                                ></span>
                              </button>
                              <!---->
                            </div>
                          </div>
                        </template>
                        <template slot="table-row" slot-scope="props">
                          <span v-if="props.column.field == 'actions'">
                            <a
                              href="#"
                              v-if="permision_role.method_read"
                              title="Detail"
                              @click.prevent="
                                detailData(props.index, props.row)
                              "
                            >
                              <i
                                class="mdi mdi-eye"
                                style="font-size: 16px"
                              ></i>
                            </a>
                          </span>

                          <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                          </span>
                        </template>
                      </vue-good-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->
        <modal
          name="detailInventory"
          :draggable="false"
          :scrollable="true"
          :height="'auto'"
        >
          <div
            class="modal fade show"
            tabindex="-1"
            style="display: block; margin-top: 2%"
            aria-modal="true"
            role="dialog"
          >
            <div class="modal-dialog modal-xl">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Detail</h5>
                  <button
                    type="button"
                    class="btn btn-default"
                    @click.prevent="removeModalsdSo()"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="exampleInputUsername1">Sku</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.sku"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">Customer Id</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.customerId"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">Warehouse Id</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.warehouseId"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">UserDefine 1</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.userDefine1"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">UserDefine 2</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.userDefine2"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">Gross Weight</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.grossWeight"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">Net Weight</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.netWeight"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">Cubic</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.cubic"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">Price</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.price"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">Lot Num</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotnum"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt01</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt01"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt02</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt02"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt03</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt03"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt04</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt04"
                        />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt05</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt05"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt06</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt06"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt07</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt07"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt08</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt08"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt09</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt09"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt10</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt10"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt11</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt11"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt12</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt12"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt15</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt15"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt16</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt16"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt17</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt17"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt18</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt18"
                        />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputUsername1">lotAtt19</label>
                        <input
                          class="form-control"
                          disabled="true"
                          :value="selectedRow?.lotAtt19"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal-footer justify-content-between">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click.prevent="removeModalsdSo()"
                  >
                    {{ this.$t("close_txt") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </modal>
        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import multiselect from "vue-multiselect";
// import DateRangePicker from "vue2-daterange-picker";
export default {
  name: "InventoryView",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    // DateRangePicker,
    multiselect,
  },
  data() {
    // const startDate = new Date(); // new Date();
    // const endDate = new Date();
    return {
      dateFilter: {
        startDate: null,
        endDate: null,
      },
      isLoading: false,
      errors: [],
      detailUser: [],
      permision_role: [],
      columns: [
        {
          label: "Sku",
          field: "sku",
          thClass: "text-center",
        },

        {
          label: "Customer Id",
          field: "customerId",
          thClass: "text-center",
        },

        {
          label: "Warehouse Id",
          field: "warehouseId",
          thClass: "text-center",
        },

        {
          label: "Qty Available",
          field: "qty",
          thClass: "text-center",
        },
        {
          label: "Qty On Hold",
          field: "qtyOnHold",
          thClass: "text-center",
        },
        {
          label: "Qty Allocate",
          field: "qtyAllocated",
          thClass: "text-center",
        },
        // {
        //   label: "Qty Replenish Out",
        //   field: "qtyRpOut",
        //   thClass: "text-center",
        // },
        // {
        //   label: "Qty Move Out",
        //   field: "qtyMvOut",
        //   thClass: "text-center",
        // },
        {
          label: "Gross Weight",
          field: "grossWeight",
          thClass: "text-center",
        },
        {
          label: "Net Weight",
          field: "netWeight",
          thClass: "text-center",
        },
        {
          label: "LotNum",
          field: "lotnum",
          thClass: "text-center",
        },

        {
          label: this.$t("action_txt"),
          field: "actions",
          thClass: "text-center",
          sortable: false,
          filterOptions: {
            customFilter: false,
          },
        },
      ],
      locale: {
        format: "yyyy-mm-dd",
      },
      rows: [],
      search: {
        sku: "",
        pageNo: "1",
        pageSize: "10",
      },
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      selectedRow: null,
      fetchFulfillment: [],
      fetchCustomer: [],
      fulfillmentSelected: null,
      companySelected: null,
    };
  },
  computed: {
    prevButtonEnabled() {
      if (this.rows.length > 0) {
        // Compare Total Rows With Per Page
        if(this.serverParams.page > 1){
          return true
        }
      }
      return false;
      // return this.serverParams.page > 1;
    },
    nextButtonEnabled() {
      if (this.rows.length > 0) {
        // Compare Total Rows With Per Page
        if (this.rows.length < this.serverParams.per_page) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    check() {
      console.log("asnu");
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },
    date(val) {
      return val ? val.toLocaleString() : "";
    },
    removeModalsdSo() {
      this.$modal.hide("detailInventory");
    },
    detailData(index, row) {
      this.$modal.show("detailInventory");
      this.selectedRow = row;
    },
    customType(ev) {
      return `${ev.code} | ${ev.name}`;
    },
    loadFullfilment() {
      const baseURI =
        this.$settings.endPointFluxOms + "v2/fulfillment/get-data-fulfillment";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchFulfillment = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    asyncSearchFulfillment(ev) {
      this.fetchFulfillment = [];
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/fulfillment/get-data-fulfillment?code=" +
        ev;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchFulfillment = response.data.datas.data;
          //console.log(this.fetchFulfillment);
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    loadCustomer() {
      const baseURI =
        this.$settings.endPointFluxOms + "v2/customer/get-data-company-oms";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCustomer = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    asyncCustomer(code) {
      this.fetchCustomer = [];
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/customer/get-data-company-oms?code=" +
        code;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCustomer = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    clearSearch() {
      this.search = {
        sku: "",
        pageNo: "1",
        pageSize: "50",
      };
      this.fulfillmentSelected = null;
      this.companySelected = null;
      this.dateFilter = {
        startDate: null,
        endDate: null,
      };
      this.rows = [];
    },
    loadItems() {
      const baseURI = this.$settings.endPointFluxOms + "v2/inventory/index";
      this.isLoading = true;
      var customerId = "";
      if (this.companySelected != null) {
        customerId = this.companySelected.code;
      }

      var warehouseId = "";
      if (this.fulfillmentSelected != null) {
        warehouseId = this.fulfillmentSelected.code;
      }
      // var invDate = "";

      // if (this.dateFilter?.startDate != null) {
      //   invDate = this.$moment(new Date(this.dateFilter.startDate)).format(
      //     "YYYY-MM-DD"
      //   );
      // }

      return this.$http
        .get(
          baseURI +
            `?pageSize=${this.serverParams.per_page}&pageNo=${this.serverParams.page}&sku=${this.search.sku}&customerId=${customerId}&warehouseId=${warehouseId}`,
          // &invDate=${invDate}
          { timeout: 120000 }
        )
        .then((response) => {
          this.isLoading = false;
          this.rows = response.data.datas.items.item;
        })
        .catch((error) => {
          this.loading();

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        // console.log(permision.permission.controller);
        if (permision.permission.controller == "InventoryController") {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },
    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },
  },
  events: {},
  created: function () {},

  mounted() {
    this.fetchIt();
    this.loading();
    // this.loadItems();
    this.loadFullfilment();
    this.loadCustomer();
  },
};
</script>

<style>
.set-height {
  min-height: 30px;
}
</style>
